<nb-card class="link-req">
  <nb-card-header>
    <h4>{{ 'dialogs.linkRequest.title' | translate }}</h4>
  </nb-card-header>

  <nb-card-body>
    <p *ngIf="loading" class="link-req__muted">
      {{ 'dialogs.linkRequest.loading' | translate }}
    </p>

    <p *ngIf="notFound" class="link-req__muted">
      {{ 'dialogs.linkRequest.notFound' | translate }}
    </p>

    <ng-container *ngIf="request && !loading">
      <dl class="link-req__facts">
        <dt>{{ 'dialogs.linkRequest.requester' | translate }}</dt>
        <dd>{{ request.requester_name || '—' }}</dd>

        <dt>{{ 'dialogs.linkRequest.twin' | translate }}</dt>
        <dd>{{ request.dozent_bot_name || '—' }}</dd>

        <dt>{{ 'dialogs.linkRequest.target' | translate }}</dt>
        <dd>
          {{ request.target_tutor_name || '—' }}
          <span class="link-req__tpl">
            {{ templateLabelKey(request.target_template) | translate }}
          </span>
        </dd>

        <dt>{{ 'dialogs.linkRequest.status' | translate }}</dt>
        <dd>
          <span class="link-req__status" [attr.data-status]="request.status">
            {{ statusKey(request.status) | translate }}
          </span>
        </dd>
      </dl>

      <div *ngIf="request.requester_note" class="link-req__note">
        <span class="link-req__note-label">
          {{ 'dialogs.linkRequest.requesterNote' | translate }}
        </span>
        <p>{{ request.requester_note }}</p>
      </div>

      <div
        *ngIf="request.decision_note && !isPending"
        class="link-req__note"
      >
        <span class="link-req__note-label">
          {{ 'dialogs.linkRequest.decisionNote' | translate }}
        </span>
        <p>{{ request.decision_note }}</p>
      </div>

      <nb-alert *ngIf="canDecide && swapWarning" status="warning" class="link-req__alert">
        {{ 'dialogs.linkRequest.swapWarning' | translate }}
      </nb-alert>

      <ng-container *ngIf="canDecide">
        <label class="link-req__label">
          {{ 'dialogs.linkRequest.decisionNoteLabel' | translate }}
        </label>
        <textarea
          nbInput
          fullWidth
          rows="2"
          [(ngModel)]="decisionNote"
          placeholder="{{ 'dialogs.linkRequest.decisionNotePlaceholder' | translate }}"
        ></textarea>
      </ng-container>
    </ng-container>
  </nb-card-body>

  <nb-card-footer>
    <button type="button" nbButton ghost (click)="dialogRef.close()">
      {{ 'buttons.close' | translate }}
    </button>
    <ng-container *ngIf="canDecide">
      <button
        type="button"
        nbButton
        status="danger"
        outline
        [disabled]="busy"
        (click)="reject()"
      >
        {{ 'dialogs.linkRequest.reject' | translate }}
      </button>
      <button
        type="button"
        nbButton
        status="primary"
        [nbSpinner]="busy"
        [disabled]="busy"
        (click)="approve()"
      >
        {{ 'dialogs.linkRequest.approve' | translate }}
      </button>
    </ng-container>
  </nb-card-footer>
</nb-card>
